export const enum ToolbarStates {
  EL_ANIMATION = 'elAnimation',
  EL_STYLE = 'elStyle',
  EL_POSITION = 'elPosition',
  SLIDE_DESIGN = 'slideDesign',
  SLIDE_ANIMATION = 'slideAnimation',
  MULTI_STYLE = 'multiStyle',
  MULTI_POSITION = 'multiPosition',
}